module.exports = __webpack_public_path__ + "img/wz-8-6-2.4b376b0f.jpg";